import type { HistoryState } from '@tanstack/react-router';
import { useNavigate } from '@tanstack/react-router';

import { IconLogoAvatar, Tooltip } from '@/_components';
import type { ToPath } from '@/types';

type AvatarShape = 'circle' | 'rectangle' | 'square';

export function CellAvatar({
  className,
  src,
  name,
  to,
  state,
  params,
  avatarShape = 'circle',
  isLarge = false,
  onClick,
  forceShow = false,
}: {
  name?: string;
  src?: string;
  className?: string;
  avatarShape?: AvatarShape;
  isLarge?: boolean;
  to?: ToPath;
  params?: Record<string, string>;
  state?: HistoryState;
  onClick?: () => void;
  forceShow?: boolean;
}) {
  const nav = useNavigate();
  const hasLink = params?.id && params.id !== 'undefined' && to;

  if (!src && !forceShow) {
    return null;
  }

  const avatarContent = (
    <IconLogoAvatar
      src={src}
      name={name}
      avatarShape={avatarShape}
      className={className}
      isLarge={isLarge}
      onClick={() => {
        if (onClick) {
          onClick();
        } else if (hasLink) {
          nav({ to, state, params });
        }
      }}
    />
  );

  const isClickable = Boolean(onClick || hasLink);
  const wrappedContent = isClickable ? <span data-row-click-ignore>{avatarContent}</span> : avatarContent;

  if (name) {
    return (
      <Tooltip content={name} zIndex={20}>
        {wrappedContent}
      </Tooltip>
    );
  }

  return wrappedContent;
}
